var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveClasses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.137,
    height: 14.141,
    viewBox: "0 0 14.137 14.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8e8e8e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-316 -845)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.431,3.414H9.776V2.707a.707.707,0,1,0-1.414,0v.707H2.707A.707.707,0,0,0,2,4.121v7.069A2.121,2.121,0,0,0,4.121,13.31H7.365L5.739,14.929a.71.71,0,1,0,1,1l1.619-1.626v1.124a.707.707,0,1,0,1.414,0V14.307l1.619,1.626a.71.71,0,1,0,1-1L10.772,13.31h3.245a2.121,2.121,0,0,0,2.121-2.121V4.121A.707.707,0,0,0,15.431,3.414Zm-.707,7.776a.707.707,0,0,1-.707.707h-9.9a.707.707,0,0,1-.707-.707V4.828h11.31Z",
    transform: "translate(314 843)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 12,
    height: 9,
    transform: "translate(317.001 847)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveClasses);
export default __webpack_public_path__ + "static/media/live-classes.a265e4aa0d117394768ccff65f77b3c8.svg";
export { ForwardRef as ReactComponent };